import { render, staticRenderFns } from "./SelectAddons.vue?vue&type=template&id=3b63151f&scoped=true&"
import script from "./SelectAddons.vue?vue&type=script&lang=js&"
export * from "./SelectAddons.vue?vue&type=script&lang=js&"
import style0 from "./SelectAddons.vue?vue&type=style&index=0&id=3b63151f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b63151f",
  null
  
)

export default component.exports